/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Unseat/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import MissingRequiredTreatmentFields from './MissingRequiredTreatmentFields/index'
import React from 'react'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'



/** @type {import('Simple/types.js').View} */
export default function Unseat({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Actions/Scheduled/Primary/Content/Unseat",
  onSubmit,
  isSubmitting
  
}) {
let unseatSubmitData = fromData.useDataSubmit({ viewPath,
context: 'unseat',
})
let unseatIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'unseat',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<TysiaButtonWithText
  viewPath={`${viewPath}/TysiaButtonWithText`}
 type="secondary"
 size="small"
 data="unseat"
 onClick={unseatSubmitData}
 disabled={unseatIsSubmittingData}
 marginLeft={dtSpaceXxs}
 text="Unseat"
/>
<MissingRequiredTreatmentFields
  viewPath={`${viewPath}/MissingRequiredTreatmentFields`}
/>
{children}
</React.Fragment>)
}